/* eslint-disable camelcase */
import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import timePicker from '../../component/timePicker.vue'
import * as toastr from 'toastr'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from '../geocoder'
import History from './history.vue'

const GOOGLE_API_KEY = GOOGLE_GEOCODE_API_KEY

if ($('#address_form').length) {
  Vue.use(VueResource)

  Vue.use(VueGoogleMaps, {
    load: {
      key: GOOGLE_API_KEY,
    },
  })

  Vue.use(Geocoder, {
    googleMapsApiKey: GOOGLE_API_KEY
  })

  new Vue({
    el: '#address_form',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      timePicker,
      SimpleSingleselect,
      History
    },
    mixins: [mixins],
    data: {
      loading: 0,
      address: {
        leavingOptionId: null,
        regionId: null,
        lockCoordinates: false,
        region: '',
        city: '',
        district: '',
        street: '',
        buildingNr: '',
        placeNr: '',
        staircaseNumber: '',
        isActive: true,
        hasPendingBags: false,
        x: 52.23682205,
        y: 21.0570343800358,
        intercomName: '',
        company_name: '',
      },
      leavingOptions: [],
      blockIsDefaultCheckbox: false,
      errors: {},
      type: [],
      deliveryTypes: [],
      regions: [],
      addressId: null,
      isMapCalling: false,
      mapLocation: null,
      displayName: '',
      markers: null,
      marker: null,
      zoom: 18,
      canChangeCords: false,
      user: null,
    },
    computed: {
      position: function () {
        return {
          lat: this.address.x,
          lng: this.address.y
        }
      },
      whyAddressCannotBeDeactivated: function () {
        if (this.address.hasPendingBags) {
          return Translator.trans('address.errors.has_pending_bags')
        }
        if (this.address.isDefault) {
          return Translator.trans('address.errors.is_default')
        }
        return null
      }
    },
    watch: {
      'address.isDefault': function (newVal) {
        if (newVal === true) {
          this.address.isActive = true
        }
      },
      'address.city': function () {
        this.changeLocation()
      },
      'address.district': function () {
        this.changeLocation()
      },
      'address.postCode': function () {
        this.changeLocation()
      },
      'address.street': function () {
        this.changeLocation()
      },
      'address.buildingNr': function () {
        this.changeLocation()
      },
      'address.placeNr': function () {
        this.changeLocation()
      },
      'mapLocation': function (newVal) {
        this.locationHasChange(newVal)
      },
    },
    mounted: function () {
      this.loading++
      this.getType()
      this.getDeliveryTypes()
      this.getRegions()
      this.address.user = $('#user_id').val()

      if ($('#entity_id').length) {
        this.addressId = $('#entity_id').val()
        this.getAddress()
      } else {
        this.canChangeCords = true
      }

      this.getUser()
      this.loading--
    },
    methods: {
      createAddress: function () {
        let url = Routing.generate('api_post_address')

        let data = { data: this.address }
        this.loading++

        this.$http.post(url, data).then(response => {
          toastr.success(Translator.trans('form.created'))

          this.errors = {}
          this.loading--

          $(location).attr('href', Routing.generate('client_show', { 'id': response.body.user_id }))
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      updateAddress: function (redirect) {
        this.loading++

        let url = Routing.generate('api_patch_address', {
          id: this.addressId,
        })

        let data = { data: this.address }

        this.$http.patch(url, data).then(response => {

          if (redirect) {
            $(location).attr('href', Routing.generate('client_show', { 'id': response.body.user_id }))
          } else {
            this.blockIsDefaultCheckbox = this.address.isDefault === true
            toastr.success(Translator.trans('form.updated'))
          }

          this.errors = {}
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getAddress: function () {
        this.loading++
        let url = Routing.generate('api_get_address', {
          id: this.addressId,
          context: 'edit'
        })

        this.$http.get(url).then(response => {
          this.address = Object.assign(response.data, {
            region: response.data.region !== null ? response.data.region.id : null,
          })
          this.blockIsDefaultCheckbox = this.address.isDefault === true
          this.loading--
          setTimeout(() => {
            this.canChangeCords = true

            if (!this.address.x || !this.address.y) {
              this.changeLocation()
            }
          }, 300)
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      changeLocation() {
        if (!this.canChangeCords || this.address.lockCoordinates) {
          return
        }

        if (this.canUsePartOfAddress(this.address.city)) {
          this.zoom = 11
        }

        if (this.canUsePartOfAddress(this.address.district)) {
          this.zoom = 15
        }

        if (this.canUsePartOfAddress(this.address.street)) {
          this.zoom = 18
        }

        if (this.canUsePartOfAddress(this.address.postCode)) {
          this.zoom = 18
        }

        if (!this.isMapCalling) {
          this.isMapCalling = true
          this.findLocation()
        }
      },
      canUsePartOfAddress(part) {
        return part && typeof part !== 'undefined'
      },
      locationHasChange(newLocation) {
        if (!newLocation) {
          this.displayName = 'Bład podczas określania lokalizacji podanego adresu'
          return
        }

        this.displayName = newLocation.formatted_address
        this.address.x = newLocation.geometry.location.lat
        this.address.y = newLocation.geometry.location.lng
      },
      dragMarker(location) {
        this.address.x = location.latLng.lat()
        this.address.y = location.latLng.lng()
      },
      findLocation() {
        Vue.$geocoder.setDefaultMode('address')
        const addressObj = {
          address_line_1: this.address.district,
          address_line_2: `${this.address.street} ${this.address.buildingNr}`,
          city: this.address.city,
          state: '',
          zip_code: this.address.postCode,
          country: 'Poland'
        }

        Vue.$geocoder.send(addressObj, response => {
          this.isMapCalling = false

          if (response && response.results && response.results[0]) {
            this.mapLocation = response.results[0]
          } else {
            this.mapLocation = null
          }
        })
      },
      assignRegionForCoordinate() {
        let url = Routing.generate('api_assign_region_point_to_region')
        this.$http.post(url, {
          x: this.address.x,
          y: this.address.y
        }).then(response => {
          let region = response.data
          if (region) {
            this.address.region = region
            this.address.regionId = region
            toastr.success(Translator.trans('address.messages.region_success'))
          } else {
            toastr.error(Translator.trans('address.messages.region_not_found'))
          }
          this.$forceUpdate()
        }, () => {
          toastr.error(Translator.trans('address.messages.region_error'))
        })
      },
      getType() {
        this.loading++
        let url = Routing.generate('api_get_tags', {
          'type': 'address_type',
          context: 'dropdown',
          exclude: ['NO_DELIVERY']
        })
        this.$http.get(url).then(response => {
          this.type = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getDeliveryTypes() {
        this.loading++
        let url = Routing.generate('api_get_tags', {
          'type': 'delivery_type',
          context: 'dropdown'
        })
        this.$http.get(url).then(response => {
          this.deliveryTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getRegions() {
        this.loading++
        let url = Routing.generate('api_get_regions_by_global', {
          context: 'dropdown',
          global: 0
        })
        this.$http.get(url).then(response => {
          this.loading--
          this.regions = response.data
        })
      },
      packageLeavingOptions() {
        this.loading++
        let url = Routing.generate('api_get_tags', {
          'type': 'package_leaving_option',
          context: 'dropdown',
          brandId: this.user.brand
        })
        this.$http.get(url).then(response => {
          this.loading--
          this.leavingOptions = response.data
        })
      },
      getUser() {
        this.loading++
        let url = Routing.generate('api_get_client', { id: this.address.user })
        this.$http.get(url).then(response => {
          this.loading--
          this.user = response.data
          this.packageLeavingOptions()
        })
      }
    }
  })
}
